import React, { Component } from "react";
import styled from "styled-components";
import uuid from "uuid";
import range from "lodash/range";
import validator from "validator";
import {
  Card,
  // CardHeader,
  CardText,
  CardTitle,
  CardActions
} from "material-ui/Card";
import TextField from "material-ui/TextField";
import CircularProgress from "material-ui/CircularProgress";
// import DatePicker from 'material-ui/DatePicker';
import SelectField from "material-ui/SelectField";
// import IconButton from 'material-ui/IconButton';
// import CloseIcon from 'material-ui/svg-icons/action/delete';
import MenuItem from "material-ui/MenuItem";
import Checkbox from "material-ui/Checkbox";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
// import Divider from 'material-ui/Divider';
// import abstract from '../../images/Rpro_4x2_V1-03_1.jpg';
import SAGHeaderLogo from "../../images/SAGHeaderLogo_tcm389-160517.png";
import logo from "../../images/logo-red.svg";
// import { theme } from '../../utils/getTheme';
// import states from '../../utils/states';
// import streams from '../../utils/streams';
// import degrees from "../../utils/degrees";
import { masterDegrees, bachelorDegrees } from "../../utils/degrees";
import { collegesNameList } from '../../utils/collegesName';
import nconf from '../../conf';
import { get, put } from '../../utils/endPoints';
// import getAction from '../../utils/SendEmail';
// import { aboutMaven, mavenPointers } from '../../static/constant';

const Wrapper = styled.div`
  background-color: ${props => props.theme.backgroundColor};
  padding: 100px 0;

  @media (max-width: 500px) {
    padding: 80px 0;
  }
`;

const BackgroundWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 320px;
  background-image: url("https://www.coupa.com/coupalink/assets/img/software-ag-logo.jpg");
  background-size: contain;
  z-index: 1;

  @media (max-width: 500px) {
    position: absolute;
  }
`;

const BrandWrapper = styled.div`
  position: relative;
  z-index: 1000;
  align-content: center;
  display: flex;
  flex: wrap;
  height: 20px;
  img {
    width: 20px;
    /* margin-top: -20px; */
  }
`;

// const LogoWrapper = styled.div`
//   position: absolute;
//   z-index: 1000;
//   top: 20px;
//   left: 24px;
//   display: flex;
//   flex: wrap;
//   height: 40px;

//   img {
//     width: 168px;
//   }

//   @media (max-width: 800px) {
//     display: none;
//   }
// `;

const InnerLogoWrapper = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: block;
    position: absolute;
    z-index: 1000;
    top: 40px;
    left: 120px;
    height: 40px;

    img {
      width: 168px;
    }
  }
`;

const TextWrapper = styled.div`
  color: ${props => props.theme.accent1Color};
  height: 20px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const ContentWrapper = styled.div`
  width: 70%;
  margin: 230px auto;
  position: relative;
  z-index: 2;

  & > * + * {
    margin-top: 32px;
  }

  @media (max-width: 700px) {
    width: calc(100vw - 32px);
  }
`;

// const ProgramHeader = styled.div`
//   height: 100px;
//   width: 90%;
//   margin: 0 auto;
//   border: 2px solid white;
//   color: white;
//   text-align: center;
//   margin-bottom: 57px;

//   & > h1 {
//     font-size: 40px;
//     letter-spacing: 1.5px;
//     font-family: Trebuchet MS;
//   }

//   @media (max-width: 800px) {
//     height: 72px;
//     & > h1 {
//       font-size: 28px;
//       letter-spacing: 1.5px;
//     }
//   }

//   @media (max-width: 500px) {
//     height: 38px;
//     & > h1 {
//       font-size: 14px;
//       letter-spacing: 1.5px;
//     }
//   }
// `;

const InfoCard = styled(Card)`
  min-height: 120px;
  overflow: hidden;

  @media (max-width: 500px) {
    min-height: 200px;
    overflow: hidden;
  }
`;

const TextFieldContainer = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// const ContentContainer = styled.div`
//   & > * {
//     margin-bottom: 16px;
//   }
// `;

// const CardIcon = styled.div`
//   position: absolute;
//   top: 12px;
//   right: 16px;
//   opacity: 0.54;
// `;

class CampaignForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      confirmModalOpen: false,
      name: "",
      nameErrorMessage: undefined,
      gender: "",
      genderErrorMessage: undefined,
      currentAddress: "",
      currentAddressErrorMessage: undefined,
      permanentAddress: "",
      permanentAddressErrorMessage: undefined,
      bachelorDegree: "",
      degreeErrorMessage: undefined,
      bachelorSpecialisation: "",
      bachelorSpecialisationErrorMessage: undefined,
      placementStatus: "",
      placementStatusErrorMessage: undefined,
      bachelorAggregate: "",
      masterDegree: "",
      masterSpecialisation: "",
      masterSemester: "",
      masterAggregate: "",
      aggregateErrorMessage: undefined,
      backlogs: undefined,
      passportAvailableStatus: undefined,
      passportAvailableStatusErrorMessage: undefined,
      willingToTravelStatus: undefined,
      willingToTravelStatusErrorMessage: undefined,
      backlogsErrorMessage: undefined,
      mobileNo: "",
      mobileNoErrorMessage: undefined,
      bachelorSemester: "",
      bachelorSemesterErrorMessage: undefined,
      emailID: "",
      emailIDerrorMessage: undefined,
      collegeName: "",
      collegeNameErrorMessage: undefined,
      hasAcceptedTerms: false,
      isLoading: true,
      completionModal: false
    };
  }

  componentWillMount() {
    get(`${nconf.get("API-ENDPOINT")}/campaign/status/fetch/${this.props.match.params.id}`)
      .then(() => {
        this.setState(() => ({
          isLoading: false
        }));
      }).catch(() => {
        this.props.history.push("/");
      });
  }

  componentDidMount() {
    this.setState(() => ({
      id: this.stringGen()
    }));
  }

  setLocation = locationSelected => {
    this.setState(() => ({
      location: locationSelected
    }));
  };

  stringGen = () => {
    var text = "MA_EB_CAND_";

    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));

    return text;
  };

  openConfimModal = () => {
    this.setState(() => ({
      confirmModalOpen: true
    }));
  };

  closeConfirmModal = () => {
    this.setState(() => ({
      confirmModalOpen: false
    }));
  };

  closeCompletionModal = () => {
    this.setState(() => ({
      completionModal: false
    }));
  };

  resetFields = () => {
    this.setState(() => ({
      name: "",
      gender: "",
      currentAddress: "",
      permanentAddress: "",
      bachelorDegree: "",
      bachelorSemester: "",
      bachelorSpecialisation: "",
      placementStatus: "",
      bachelorAggregate: "",
      masterDegree: "",
      masterSpecialisation: "",
      masterSemester: "",
      masterAggregate: "",
      backlogs: undefined,
      passportAvailableStatus: undefined,
      willingToTravelStatus: undefined,
      mobileNo: "",
      emailID: "",
      collegeName: "",
      hasAcceptedTerms: false,
      showIDTypes: false
    }));
  };

  validateInfo = () => {
    const {
      name,
      gender,
      currentAddress,
      permanentAddress,
      bachelorDegree,
      bachelorSemester,
      bachelorSpecialisation,
      placementStatus,
      passportAvailableStatus,
      bachelorAggregate,
      masterAggregate,
      backlogs,
      mobileNo,
      emailID,
      collegeName,
      willingToTravelStatus
    } = this.state;
    let isDirty = false;

    if (validator.isEmpty(name)) {
      this.setState(() => ({
        nameErrorMessage: "Name of candidate is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        nameErrorMessage: undefined
      }));
    }
    if (validator.isEmpty(collegeName)) {
      this.setState(() => ({
        collegeNameErrorMessage: "College name of candidate is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        collegeNameErrorMessage: undefined
      }));
    }
    if (validator.isEmpty(bachelorSemester)) {
      this.setState(() => ({
        bachelorSemesterErrorMessage: "Bachelor Semester is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        bachelorSemesterErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(gender)) {
      this.setState(() => ({
        genderErrorMessage: "Gender is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        genderErrorMessage: undefined
      }));
    }
    if (validator.isEmpty(bachelorDegree)) {
      this.setState(() => ({
        bachelorDegreeErrorMessage: "Bachelor Degree is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        bachelorDegreeErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(bachelorSpecialisation)) {
      this.setState(() => ({
        bachelorSpecialisationErrorMessage: "Bachelor Specialisation is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        bachelorSpecialisationErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(currentAddress)) {
      this.setState(() => ({
        currentAddressErrorMessage: "Address is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        currentAddressErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(permanentAddress)) {
      this.setState(() => ({
        permanentAddressErrorMessage: "Address is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        permanentAddressErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(placementStatus)) {
      this.setState(() => ({
        placementStatusErrorMessage: "Placement Status is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        placementStatusErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(bachelorAggregate)) {
      this.setState(() => ({
        bachelorAggregateErrorMessage: "Gradudation percentage is required"
      }));
      isDirty = true;
    } else if (bachelorAggregate > 100) {
      this.setState(() => ({
        bachelorAggregateErrorMessage:
          "Gradudation percentage should not be greater than 100"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        bachelorAggregateErrorMessage: undefined
      }));
    }

    if (masterAggregate > 100) {
      this.setState(() => ({
        masterAggregateErrorMessage:
          "Post Gradudation percentage should not be greater than 100"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        masterAggregateErrorMessage: undefined
      }));
    }

    if (typeof backlogs === "undefined") {
      this.setState(() => ({
        backlogsErrorMessage: "Number of Backlogs is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        backlogsErrorMessage: undefined
      }));
    }

    if (typeof passportAvailableStatus === "undefined") {
      this.setState(() => ({
        passportAvailableStatusErrorMessage:
          "Passport Available Status is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        passportAvailableStatusErrorMessage: undefined
      }));
    }

    if (typeof willingToTravelStatus === "undefined") {
      this.setState(() => ({
        willingToTravelStatusErrorMessage:
          "Willing To Travel Status is required"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        willingToTravelStatusErrorMessage: undefined
      }));
    }

    const regularEpxression = /^[0-9]+$/;
    if (validator.isEmpty(mobileNo)) {
      this.setState(() => ({
        mobileNoErrorMessage: "Primary contact is required"
      }));
      isDirty = true;
    } else if (mobileNo < 7000000000 || mobileNo > 9999999999) {
      this.setState(() => ({
        mobileNoErrorMessage: "Enter 10 Numerals"
      }));
      isDirty = true;
    } else if (!regularEpxression.test(mobileNo)) {
      this.setState(() => ({
        mobileNoErrorMessage: "Incorrect format"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        mobileNoErrorMessage: undefined
      }));
    }

    if (validator.isEmpty(emailID)) {
      this.setState(() => ({
        emailIDerrorMessage: "Primary email is required"
      }));
      isDirty = true;
    } else if (!validator.isEmail(emailID.replace(/\s/g, ""))) {
      this.setState(() => ({
        emailIDerrorMessage: "Incorrect format"
      }));
      isDirty = true;
    } else {
      this.setState(() => ({
        emailIDerrorMessage: undefined
      }));
    }

    return isDirty;
  };

  createCandidate = () => {
    this.setState(() => ({
      isLoading: true
    }));
    const { match } = this.props;
    const {
      id,
      name,
      gender,
      currentAddress,
      permanentAddress,
      bachelorDegree,
      bachelorSpecialisation,
      bachelorSemester,
      masterDegree,
      masterSpecialisation,
      masterSemester,
      masterAggregate,
      passportAvailableStatus,
      willingToTravelStatus,
      placementStatus,
      bachelorAggregate,
      backlogs,
      mobileNo,
      emailID,
      collegeName
    } = this.state;

    const now = new Date().getTime();
    const candidateId = uuid.v4() + now;
    const candidate = {
      id,
      name,
      gender,
      currentAddress,
      permanentAddress,
      passportAvailableStatus,
      willingToTravelStatus,
      bachelorDegree,
      bachelorSpecialisation,
      bachelorSemester,
      bachelorAggregate,


      masterDegree,
      masterSpecialisation,
      masterSemester,
      masterAggregate,
      placementStatus,
      backlogs,
      mobileNo,
      emailID,
      collegeName
    };

    put(`${nconf.get("API-ENDPOINT")}/candidateRegistration/campaign/save/${match.params.id}`,{
      candidateId,
      ...candidate,
      timestamp: now
    })
    .then(() => {
      this.setState(() => ({
        confirmModalOpen: false,
        isLoading: false,
        completionModal: true
      }));
      this.resetFields();
    });
  };

  render() {
    const {
      id,
      confirmModalOpen,
      name,
      nameErrorMessage,
      collegeNameErrorMessage,
      gender,
      genderErrorMessage,
      currentAddress,
      currentAddressErrorMessage,
      permanentAddress,
      permanentAddressErrorMessage,
      passportAvailableStatus,
      passportAvailableStatusErrorMessage,
      willingToTravelStatus,
      willingToTravelStatusErrorMessage,
      bachelorDegree,
      bachelorDegreeErrorMessage,
      bachelorSemester,
      bachelorSemesterErrorMessage,
      bachelorSpecialisation,
      bachelorSpecialisationErrorMessage,
      bachelorAggregate,
      bachelorAggregateErrorMessage,
      
      masterDegree,
      masterDegreeErrorMessage,
      masterSemester,
      masterSemesterErrorMessage,
      masterSpecialisation,
      masterSpecialisationErrorMessage,
      masterAggregate,
      masterAggregateErrorMessage,

      placementStatus,
      placementStatusErrorMessage,
      backlogs,
      backlogsErrorMessage,
      mobileNo,
      mobileNoErrorMessage,
      emailID,
      emailIDerrorMessage,
      collegeName,
      hasAcceptedTerms,
      isLoading,
      completionModal
    } = this.state;
    return (
      <div>
        {isLoading ? (
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        ) : (
          <Wrapper>
            <BackgroundWrapper>
              {/* <LogoWrapper>
                  <img src={SAGHeaderLogo} alt="CampuScape" />
                </LogoWrapper> */}
            </BackgroundWrapper>
            <InnerLogoWrapper>
              <img src={SAGHeaderLogo} alt="CampuScape" />
            </InnerLogoWrapper>
            <ContentWrapper>
              {/* <ProgramHeader>
                  <h1>Define Goals ~ Design Success</h1>
                </ProgramHeader> */}
              <InfoCard>
                <CardText style={{ paddingTop: 0 }}>
                    
                    <p>
                      <h3>Dear Candidate,</h3>
                      <b>Greetings!!</b><br /><br />
                      SoftwareAG is in a search of young enthusiastic engineers to help us in delivering the projects for our Bengaluru
    Centre.<br /><br />

                      <b><u>Position: Product Development and Testing</u></b><br /><br />
                      &middot;<b> Drive Date:</b> 4th April&rsquo; 2019<br />
                      &middot;<b> Drive Location:</b> Bangalore (Venue will be informed later)<br />
                      &middot;<b> Eligibility Percentage:</b> 60%<br />
                      &middot;<b> Eligible Degrees:</b> BE Computer science, MCA<br />
                      &middot;<b> Year of Graduation:</b> 2019<br />
                      &middot;<b> Stipend:</b> 15,500 / Month<br />
                      <br />
                      <b>Process:</b><br /><br />
                      &middot; Online Test<br />
                      &middot; Technical Interview<br />
                      &middot; HR Interview
                    </p>
                </CardText>
              
                <CardTitle title="About">
                    <p>Software AG is the industry’s leading independent integration, Internet of Things, analytics, process software and services company. We are trusted by over 70% of the world’s top 1,000 enterprises. Software AG transforms your business and drives enterprise innovation by helping you connect and integrate everything—from applications and devices to data and clouds. We help you free data—even data in motion—from silos to “democratize” it and make it shareable across your organization—any time it is needed, anywhere and by anyone.Software AG is the industry’s leading independent integration, Internet of Things, analytics, process software and services company. We are trusted by over 70% of the world’s top 1,000 enterprises. Software AG transforms your business and drives enterprise innovation by helping you connect and integrate everything—from applications and devices to data and clouds. We help you free data—even data in motion—from silos to “democratize” it and make it shareable across your organization—any time it is needed, anywhere and by anyone.</p>
                    <br />
                    <p>We give you the freedom and flexibility to connect and integrate any technology—from app to edge—to unlock the power of your data. We are UX and customer obsessed. We constantly seek new ways to empower you through integration, APIs, analytics, the Internet of Things and business transformation software that enables you to out-pace your rivals and lead your industry. We offer you freedom—as a service—to give you choice, agility and a competitive edge.</p>
                    <br />
                    <p>Software AG has more than 4,700 employees, is active in 70 countries and had revenues of €866 million in 2018.</p>
                    <br /><br />
                </CardTitle>
              </InfoCard>
              <Card>
                <CardText>
                  <CardTitle title="Candidate Information" />
                  <TextField
                    floatingLabelText="Candidate Name  *"
                    hintText="Name of the Candidate"
                    fullWidth
                    value={name}
                    onChange={(_, value) => {
                      this.setState(() => ({ name: value }));
                    }}
                    errorText={nameErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="College Name *"
                    hintText="Name of the College in which the candidate is studying"
                    fullWidth
                    value={collegeName}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ collegeName: value }));
                    }}
                    errorText={collegeNameErrorMessage}
                  >
                    {collegesNameList.map(collegeName => (
                      <MenuItem
                        key={collegeName}
                        value={collegeName}
                        primaryText={collegeName}
                      />
                    ))}
                  </SelectField>

                  <SelectField
                    floatingLabelText="UG Degree *"
                    hintText=""
                    fullWidth
                    value={bachelorDegree}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ bachelorDegree: value }));
                    }}
                    errorText={bachelorDegreeErrorMessage}
                  >
                    {bachelorDegrees.map(degree => (
                      <MenuItem
                        key={degree}
                        value={degree}
                        primaryText={degree}
                      />
                    ))}
                  </SelectField>
                  <TextField
                    floatingLabelText="UG Specialisation *"
                    hintText="Enter your Branch"
                    fullWidth
                    value={bachelorSpecialisation}
                    onChange={(_, value) => {
                      this.setState(() => ({ bachelorSpecialisation: value }));
                    }}
                    errorText={bachelorSpecialisationErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="Current UG Semester *"
                    hintText="Enter your Semester"
                    fullWidth
                    value={bachelorSemester}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ bachelorSemester: value }));
                    }}
                    errorText={bachelorSemesterErrorMessage}
                  >
                    {range(1,9)
                      .map(String)
                      .map(numberOfBackLogs => (
                      <MenuItem
                        key={numberOfBackLogs}
                        value={numberOfBackLogs}
                        primaryText={numberOfBackLogs}
                      />
                    ))}
                    <MenuItem
                      key='PASSED'
                      value='PASSED'
                      primaryText='PASSED'
                    />
                    <MenuItem
                      key='N/A'
                      value='N/A'
                      primaryText='N/A'
                    />
                  </SelectField>
                  
                  <TextField
                    floatingLabelText="UG Aggregate *"
                    hintText="Please enter percentage"
                    fullWidth
                    value={bachelorAggregate}
                    onChange={(_, value) => {
                      this.setState(() => ({ bachelorAggregate: value }));
                    }}
                    errorText={bachelorAggregateErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="PG Degree"
                    hintText=""
                    fullWidth
                    value={masterDegree}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ masterDegree: value }));
                    }}
                    errorText={masterDegreeErrorMessage}
                  >
                    {masterDegrees.map(degree => (
                      <MenuItem
                        key={degree}
                        value={degree}
                        primaryText={degree}
                      />
                    ))}
                  </SelectField>
                  <TextField
                    floatingLabelText="PG Specialisation"
                    hintText="Enter your Branch"
                    fullWidth
                    value={masterSpecialisation}
                    onChange={(_, value) => {
                      this.setState(() => ({ masterSpecialisation: value }));
                    }}
                    errorText={masterSpecialisationErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="Current PG Semester"
                    hintText="Enter your Semester"
                    fullWidth
                    value={masterSemester}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ masterSemester: value }));
                    }}
                    errorText={masterSemesterErrorMessage}
                  >
                    {range(1,9)
                      .map(String)
                      .map(numberOfBackLogs => (
                      <MenuItem
                        key={numberOfBackLogs}
                        value={numberOfBackLogs}
                        primaryText={numberOfBackLogs}
                      />
                    ))}
                    <MenuItem
                      key='PASSED'
                      value='PASSED'
                      primaryText='PASSED'
                    />
                    <MenuItem
                      key='N/A'
                      value='N/A'
                      primaryText='N/A'
                    />
                  </SelectField>
                  <TextField
                    floatingLabelText="PG Aggregate"
                    hintText="Please enter percentage"
                    fullWidth
                    value={masterAggregate}
                    onChange={(_, value) => {
                      this.setState(() => ({ masterAggregate: value }));
                    }}
                    errorText={masterAggregateErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="Placement Status *"
                    hintText="Placed or Unplaced"
                    fullWidth
                    value={placementStatus}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ placementStatus: value }));
                    }}
                    errorText={placementStatusErrorMessage}
                  >
                    <MenuItem value="Not Placed" primaryText="Not Placed" />
                    <MenuItem
                      value="Placed, Want to Upgrade Skills"
                      primaryText="Placed, Want to Upgrade Skills"
                    />
                    <MenuItem
                      value="Aspiring For Higher Studies"
                      primaryText="Aspiring For Higher Studies"
                    />
                  </SelectField>
                  <SelectField
                    floatingLabelText="Current Backlogs *"
                    fullWidth
                    value={backlogs}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ backlogs: value }));
                    }}
                    errorText={backlogsErrorMessage}
                  >
                    {range(0, 25).map(val => (
                      <MenuItem
                        value={val}
                        key={val}
                        primaryText={val.toString()}
                      />
                    ))}
                  </SelectField>
                </CardText>
                <CardTitle title="Personal Information" />
                <CardText style={{ paddingTop: 0 }}>
                  <SelectField
                    floatingLabelText="Gender *"
                    hintText="Gender of the Candidate"
                    fullWidth
                    value={gender}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ gender: value }));
                    }}
                    errorText={genderErrorMessage}
                  >
                    <MenuItem value="FEMALE" primaryText="FEMALE" />
                    <MenuItem value="MALE" primaryText="MALE" />
                  </SelectField>

                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="Contact Number *"
                      style={{ width: "48%" }}
                      value={mobileNo}
                      onChange={(_, value) => {
                        this.setState(() => ({
                          mobileNo: value.replace(/\s/g, "")
                        }));
                      }}
                      errorText={mobileNoErrorMessage}
                    />
                    <TextField
                      floatingLabelText="Email ID*"
                      style={{ width: "48%" }}
                      value={emailID}
                      onChange={(_, value) => {
                        this.setState(() => ({
                          emailID: value.replace(/\s/g, "")
                        }));
                      }}
                      errorText={emailIDerrorMessage}
                    />
                  </TextFieldContainer>

                  <SelectField
                    floatingLabelText="Passport *"
                    fullWidth
                    value={passportAvailableStatus}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ passportAvailableStatus: value }));
                    }}
                    errorText={passportAvailableStatusErrorMessage}
                  >
                    <MenuItem value="yes" primaryText="Yes" />
                    <MenuItem value="no" primaryText="No" />
                  </SelectField>

                  <SelectField
                    floatingLabelText="Willing To Travel *"
                    fullWidth
                    value={willingToTravelStatus}
                    onChange={(_, index, value) => {
                      this.setState(() => ({ willingToTravelStatus: value }));
                    }}
                    errorText={willingToTravelStatusErrorMessage}
                  >
                    <MenuItem value="yes" primaryText="Yes" />
                    <MenuItem value="no" primaryText="No" />
                  </SelectField>

                  <TextField
                    floatingLabelText="Current Address *"
                    hintText="Address is required"
                    fullWidth
                    value={currentAddress}
                    onChange={(_, value) => {
                      this.setState(() => ({ currentAddress: value }));
                    }}
                    errorText={currentAddressErrorMessage}
                  />
                  <TextField
                    floatingLabelText="Permanent Address *"
                    hintText="Address is required"
                    fullWidth
                    value={permanentAddress}
                    onChange={(_, value) => {
                      this.setState(() => ({ permanentAddress: value }));
                    }}
                    errorText={permanentAddressErrorMessage}
                  />
                </CardText>
              </Card>
              <Card>
                <CardText>
                  <Checkbox
                    label="I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief and I undertake to inform you of any changes therein, immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it. I hereby authorize sharing of the information furnished on this form with the MyAnatomy Integration Pvt Ltd and to use the information provided by me for their own business purpose and advertisement. I further declare that MyAnatomy Integration Pvt Ltd is not charging any professional fees in any form or manner from us for participating in this recruitment cum campaign."
                    checked={hasAcceptedTerms}
                    onCheck={(_, check) => {
                      this.setState(() => ({ hasAcceptedTerms: check }));
                    }}
                  />
                </CardText>
                <CardActions>
                  <RaisedButton
                    label="Submit"
                    primary
                    disabled={!hasAcceptedTerms}
                    onTouchTap={() => {
                      if (!this.validateInfo()) {
                        this.openConfimModal();
                      }
                    }}
                  />
                </CardActions>
              </Card>
              {/* <Card> */}
              <BrandWrapper>
                <TextWrapper>Powered By&nbsp;</TextWrapper>
                <img src={logo} alt="MyAnatomy" />
              </BrandWrapper>
              {/* </Card> */}
            </ContentWrapper>

            <Dialog
              title="Create"
              modal
              actions={[
                <FlatButton
                  label="Cancel"
                  primary
                  onTouchTap={this.closeConfirmModal}
                />,
                <RaisedButton
                  label="Submit"
                  primary
                  onTouchTap={() => {
                    this.createCandidate();
                    this.resetFields();
                  }}
                />
              ]}
              open={confirmModalOpen}
              onRequestClose={this.closeConfirmModal}
            >
              <CardText>
                Please confirm the data that you have filled. Are you sure?
              </CardText>
            </Dialog>

            <Dialog
              title="Success"
              modal
              open={completionModal}
              actions={
                <RaisedButton
                  label="OK"
                  primary
                  onTouchTap={this.closeCompletionModal}
                />
              }
            >
              <CardText>
                You have successfully registered with Resource Pro Campaign.
                <br /> <br />
                Please note your Refrence ID is <b>{id}</b>
              </CardText>
            </Dialog>
          </Wrapper>
        )}
      </div>
    );
  }
}

export default CampaignForm;



// WEBPACK FOOTER //
// ./src/views/CampaignForm/CampaignForm.js